import React, { useCallback, useEffect, useState } from "react";
import {
  AbsoluteFill,
  Sequence,
  continueRender,
  delayRender,
  staticFile,
} from "remotion";
import type { SurveyVideoProps } from "../lib/schema";
import { BG_GRADIENT } from "../lib/colors";
import type { StatData } from "../types/stats";
import Intro from "./scenes/Intro";
import MainGraph from "./scenes/MainGraph";
import Outro from "./scenes/Outro";

/** フレーム定数 */
const INTRO_START = 0;
const INTRO_DURATION = 150; // 5s
const MAIN_START = 150;
const MAIN_DURATION = 720; // 24s
const OUTRO_START = 870;
const OUTRO_DURATION = 150; // 5s

const SurveyVideo: React.FC<SurveyVideoProps> = ({ itemX, itemY, cities, outlierSigma }) => {
  const [data, setData] = useState<StatData | null>(null);
  const [handle] = useState(() => delayRender("Loading stats.json"));

  const fetchData = useCallback(async () => {
    try {
      const res = await fetch(staticFile("stats.json"));
      const json: StatData = await res.json();
      setData(json);
      continueRender(handle);
    } catch (e) {
      console.error("Failed to load stats.json:", e);
      continueRender(handle);
    }
  }, [handle]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (!data) return null;

  const sceneProps = { itemX, itemY, cities, data, outlierSigma };

  return (
    <AbsoluteFill style={{ background: BG_GRADIENT }}>
      <Sequence
        from={INTRO_START}
        durationInFrames={INTRO_DURATION}
        premountFor={30}
      >
        <Intro {...sceneProps} />
      </Sequence>

      <Sequence
        from={MAIN_START}
        durationInFrames={MAIN_DURATION}
        premountFor={30}
      >
        <MainGraph {...sceneProps} globalStartFrame={MAIN_START} />
      </Sequence>

      <Sequence
        from={OUTRO_START}
        durationInFrames={OUTRO_DURATION}
        premountFor={30}
      >
        <Outro {...sceneProps} />
      </Sequence>
    </AbsoluteFill>
  );
};

export default SurveyVideo;
